import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { MasterRecordsProvider } from './contexts/MasterRecordsContext';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Seo from './components/Seo/Seo';
import BackToTop from './components/BackToTop/BackToTop';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import SafetyValveService from './pages/Services/SafetyValveService/SafetyValveService';
import ActuatorService from './pages/Services/ActuatorService/ActuatorService';
import ValveService from './pages/Services/ValveService/ValveService';
import ArcValveService from './pages/Services/ArcValveService/ArcValveService';
import BFPService from './pages/Services/BFPService/BFPService';
import SparesService from './pages/Services/SparesService/SparesService';
import WorkshopService from './pages/Services/WorkshopService/WorkshopService';
import Contact from './pages/Contact/Contact';
import Careers from './pages/Careers/Careers';
import OurClients from './pages/OurClients/OurClients';
import AdminLogin from './pages/Admin/AdminLogin';
import AdminDashboard from './pages/Admin/AdminDashboard';
import LeadsManagement from './pages/Admin/LeadsManagement';
import MasterRecords from './pages/Admin/MasterRecords';
import WebsiteMasterRecords from './pages/Admin/WebsiteMasterRecords';
import AdminPortalMasterRecords from './pages/Admin/AdminPortalMasterRecords';
import AdminSettings from './pages/Admin/AdminSettings';
import AdminLayout from './components/Admin/AdminLayout';
import ProtectedRoute from './components/Admin/ProtectedRoute';
import './index.css';
import './styles/App.css';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <MasterRecordsProvider>
          <AuthProvider>
          <Router>
            <ScrollToTop />
            <Seo />
            <div className="App min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
              <AnimatePresence mode="wait">
                <Routes>
                {/* Public Routes */}
                <Route path="/" element={
                  <>
                    <Navbar />
                    <Home />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/about" element={
                  <>
                    <Navbar />
                    <About />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services" element={
                  <>
                    <Navbar />
                    <Services />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/safety-valve" element={
                  <>
                    <Navbar />
                    <SafetyValveService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/actuator" element={
                  <>
                    <Navbar />
                    <ActuatorService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/valve-service" element={
                  <>
                    <Navbar />
                    <ValveService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/arc-valve" element={
                  <>
                    <Navbar />
                    <ArcValveService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/bfp-service" element={
                  <>
                    <Navbar />
                    <BFPService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/spares" element={
                  <>
                    <Navbar />
                    <SparesService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/services/workshop" element={
                  <>
                    <Navbar />
                    <WorkshopService />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/contact" element={
                  <>
                    <Navbar />
                    <Contact />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/careers" element={
                  <>
                    <Navbar />
                    <Careers />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                <Route path="/our-clients" element={
                  <>
                    <Navbar />
                    <OurClients />
                    <Footer />
                    <BackToTop />
                  </>
                } />
                
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={
                  <ProtectedRoute>
                    <AdminLayout title="Dashboard">
                      <AdminDashboard />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                <Route path="/admin/leads" element={
                  <ProtectedRoute>
                    <AdminLayout title="Leads Management">
                      <LeadsManagement />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                <Route path="/admin/master-records" element={
                  <ProtectedRoute>
                    <AdminLayout title="Master Records">
                      <MasterRecords />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                <Route path="/admin/master-records/website" element={
                  <ProtectedRoute>
                    <AdminLayout title="Website Master Records">
                      <WebsiteMasterRecords />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                <Route path="/admin/master-records/admin-portal" element={
                  <ProtectedRoute>
                    <AdminLayout title="Admin Portal Master Records">
                      <AdminPortalMasterRecords />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                <Route path="/admin/settings" element={
                  <ProtectedRoute>
                    <AdminLayout title="Settings">
                      <AdminSettings />
                    </AdminLayout>
                  </ProtectedRoute>
                } />
                
                <Route path="*" element={
                  <>
                    <Navbar />
                    <Home />
                    <Footer />
                    <BackToTop />
                  </>
                } />
              </Routes>
            </AnimatePresence>
            <Toaster position="top-right" />
            </div>
          </Router>
          </AuthProvider>
        </MasterRecordsProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;


